import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const DevSettings = withLazyFallback(
  () => import('components/admin/pages/DevSettings/DevSettings')
);
const FeatureFlags = withLazyFallback(
  () => import('components/admin/pages/DevSettings/components/FeatureFlags/FeatureFlags')
);

const ADMIN_DEV_SETTINGS = [
  {
    path: 'dev-settings',
    element: <DevSettings />,
    handle: { title: 'Dev settings' },
    children: [
      { path: 'feature-flags', element: <FeatureFlags />, handle: { title: 'Feature flags' } }
    ]
  }
];

export default ADMIN_DEV_SETTINGS;
